import React from 'react';

export interface HeroSectionProps {
  title: string;
  subtitle?: string;
  buttonText?: string;
  buttonUrl?: string;
  /** Custom call to action, rendered instead of buttonText/buttonUrl. Use for external links. */
  action?: React.ReactNode;
  backgroundImage: string; // single URL
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  buttonText,
  buttonUrl,
  action,
  backgroundImage,
}) => {
  return (
    <section className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden">
      <img
        src={backgroundImage}
        alt="Background for hero"
        className="absolute inset-0 w-full h-full object-cover z-0"
        loading="eager"
        fetchPriority="high"
        decoding="async"
        height={1440}
        width={1440}
      />

      {/* Overlay ABOVE the image */}
      <div className="absolute inset-0 bg-black/40 z-10" />

      {/* Content ABOVE overlay */}
      <div className="relative z-20 max-w-3xl mx-auto text-center md:text-left px-4">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">{title}</h1>
        {subtitle && <p className="text-lg md:text-xl text-gray-200 mb-6">{subtitle}</p>}
        {action}
        {!action && buttonText && buttonUrl && (
          <a
            href={buttonUrl}
            className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-medium uppercase tracking-wide px-6 py-3 rounded-full transition"
          >
            {buttonText}
          </a>
        )}
      </div>
    </section>
  );
};
